import { CategoryFilterKey } from '../domain';
import { useSetFilter } from '../../filter';

export const useSetCategoryListFilter = () => {
  return useSetFilter(CategoryFilterKey, 'categoryFilter', true);
};
